function waitForCustomerReferralLoaded(a, b = 100) {
  const c = setInterval(function () {
    "undefined" != typeof uppromoteCustomerReferral && (a(), clearInterval(c));
  }, b);
  setTimeout(function () {
    clearInterval(c);
  }, 5e3);
}
function waitElementLoaded(a, b, c = 100) {
  const d = setInterval(function () {
    const c = document.querySelector(a);
    c && (b(), clearInterval(d));
  }, c);
  setTimeout(function () {
    clearInterval(d);
  }, 5e3);
}
const customerReferralItemSelector = `input#sca_customer_refer_email`;
waitElementLoaded(customerReferralItemSelector, function () {
  waitForCustomerReferralLoaded(function () {
    var input = document.getElementById ("sca_customer_refer_email");
    input.placeholder = "Ingresa tu email";
  });
});


const ckInterval = setInterval(() => {
  if (typeof CHOpenChatInNewTab !== "undefined") {
    clearInterval(ckInterval)
    window.CHOpenChatInNewTab = function (phoneNumber) {
      phoneNumber = phoneNumber.replace("+", "");
      let link = `https://web.whatsapp.com/send`;

      if (CH_isMobile()) {
        link = `https://api.whatsapp.com/send`;
      }

      if (CH_isFacebookIBA()) {
        link = `whatsapp://send`;
      }

      let url = `${link}/?phone=${phoneNumber}`;
      if (chConfig.addProductUrlInMessage && chIsProductPage()) {
        url = `${url}&text="Hola, estoy viendo su sitio web y tengo una consulta. ${location.href}`;
      }else{
        url = `${url}&text=Hola, estoy viendo su sitio web y tengo una consulta.`;
      }
      window.open(url, "_blank");
      updateChAnalyticEvent("chat_clicked");
    };
  }
}, 1000);